module.exports = __webpack_public_path__ + "img/plus-symbol.83a2b535.svg";